import Vue from "vue";
import Vuex from "vuex";
import { auth } from "./modules/auth.store";

Vue.use(Vuex);

const apiUrl = process.env.VUE_APP_API_SERVER;

export default new Vuex.Store({
  state: {
    apiUrl,
    user: null,
    authGroups: [],
  },
  getters: {
    isAdminUser: (state) => {
      return true;
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth
  },
});
